import { replace } from "@/services/useful";


    // LOCALHOST
        export function LOCALHOST()
        {
            if(window.location.href.split('http://localhost:')[1]){
                return 1;
            }
            return 0;
        }
    // LOCALHOST







    // APP
        export function APP()
        {
            return ($_APP!=undefined ? $_APP : 0);
        }
    // APP



    // HOST
        export function HOST() // HTTPS:DOMINIO/DIR
        {
            return window.location.origin;
        }
    // HOST



    // DIR
        export function DIR() // HTTPS:DOMINIO/DIR
        {
            return `${window.location.origin}${$_GLOBAL.DIR}`
        }
    // DIR



    // DIR__
        export function DIR__() // /DIR
        {
            return `${$_GLOBAL.DIR}/`;
        }
    // DIR__



    // DIR__P
        export function DIR__P() // PUBLIC_HTML
        {
            return `${$_GLOBAL.DIR_API}/../..`;
        }
    // DIR__P



    // DIR__API
        export function DIR__API() // PUBLIC_HTML/PHP/API
        {
            return $_GLOBAL.DIR_API;
        }
    // DIR__API



    // DIR__PHP
        export function DIR__PHP() // PUBLIC_HTML/PHP
        {
            return `${$_GLOBAL.DIR_API}/..`;
        }
    // DIR__PHP



    // DIR__APP
    export function DIR__APP() // .APP
    {
        return `${$_GLOBAL.DIR_API}/../../../.app`;
    }
    // DIR__APP

    

    // DIR__DATA
        export function DIR__DATA() // .DATA
        {
            return `${$_GLOBAL.DIR_API}/../../../.data`;
        }
    // DIR__DATA
